function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";
import styled from "styled-components";
import { space, color } from "styled-system";
var Svg = styled("svg")({
  flex: "none"
}, space, color);
var SvgBpt = React.forwardRef(function (props, ref) {
  return React.createElement(Svg, _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "currentcolor",
    height: props.size,
    width: props.size,
    ref: ref
  }), React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z",
    fill: "inherit"
  }), React.createElement("path", {
    d: "M19.413 15.553a5.161 5.161 0 01-.238.435c-.058.103-.113.207-.174.305-.027.046-.05.093-.078.137h-.009a8.172 8.172 0 01-11.469 2.435c-.037-.026-.07-.053-.106-.078a5.29 5.29 0 01-.412-.296c-.21-.16-.41-.33-.6-.513a7.382 7.382 0 01-.266-.26c-.093-.095-.174-.187-.269-.294a9.369 9.369 0 01-.277-.327 7.338 7.338 0 01-.205-.274 8.57 8.57 0 01-.265-.387 7.522 7.522 0 01-.158-.26 7.114 7.114 0 01-.366-.697c-.07-.149-.135-.3-.197-.452-.038-.095-.071-.19-.105-.286-.052-.15-.103-.307-.147-.454-.03-.107-.049-.208-.082-.318a7.794 7.794 0 01-.1-.442c-.015-.112-.04-.231-.05-.337a9.048 9.048 0 01-.055-.443c-.01-.116-.023-.232-.023-.35-.012-.146-.012-.294-.012-.442 0-.113.009-.225.009-.338a8.284 8.284 0 01.658-2.88c.017-.042.037-.092.048-.126a.255.255 0 01.06-.099c.077-.166.162-.331.252-.495.043-.091.095-.181.148-.27.038-.064.063-.125.113-.195.048-.071.104-.145.154-.218a7.458 7.458 0 01.5-.667c.178-.211.367-.414.566-.606.074-.07.146-.139.221-.205a12.222 12.222 0 01.623-.5c.142-.098.286-.197.431-.295.078-.05.156-.1.236-.147a7.953 7.953 0 011.476-.69 7.92 7.92 0 011.134-.313 9.1 9.1 0 01.762-.116c.167-.018.335-.03.504-.038.092-.007.185-.007.278-.007a7.92 7.92 0 012.401.339c.158.045.306.094.453.148.11.04.222.082.33.128.083.034.167.06.25.098v.011a8.172 8.172 0 014.103 10.99c-.015.032-.033.058-.047.089zM8.871 18.928v-.002a7.61 7.61 0 009.588-2.95c.054-.09.105-.183.156-.274.07-.135.15-.265.218-.412a7.565 7.565 0 00-3.966-10.322 5.804 5.804 0 00-.295-.116 8.494 8.494 0 00-.718-.22 7.423 7.423 0 00-1.195-.203l-.253-.018a10.525 10.525 0 00-.485-.011h-.253a8.056 8.056 0 00-.746.068 6.84 6.84 0 00-.742.143c-.247.06-.49.132-.728.218a5.794 5.794 0 00-.306.114c-.219.09-.434.188-.645.295-.214.11-.423.231-.627.36-.135.085-.269.176-.4.274a3.61 3.61 0 00-.2.147c-.197.156-.386.321-.567.495a7.963 7.963 0 00-.801.911c-.156.21-.302.426-.437.649-.049.08-.093.162-.139.243a7.648 7.648 0 00-.596 1.393 5.94 5.94 0 00-.2.743c-.032.157-.059.317-.08.476-.013.091-.026.184-.034.276-.015.148-.032.295-.032.443-.009.1-.009.202-.009.303 0 .14.012.28.012.42.013.244.038.487.074.728.02.101.036.197.054.306.027.139.06.277.093.416a7.153 7.153 0 00.214.707c.031.086.06.173.095.258.056.142.117.28.175.425.038.08.075.162.117.242.073.134.144.267.22.398.051.081.098.16.149.24.076.121.16.239.244.357.062.086.107.156.189.254.081.097.173.203.252.294.08.092.168.191.247.274.08.082.142.14.245.238a6.265 6.265 0 00.55.473 7.6 7.6 0 001.562.947zm3.114-.619a6.314 6.314 0 116.309-6.317 6.321 6.321 0 01-6.309 6.317zm0-10.559a4.245 4.245 0 102.997 1.244 4.25 4.25 0 00-2.997-1.247v.003z",
    fill: "white"
  }));
});
SvgBpt.displayName = "SvgBpt";
SvgBpt.defaultProps = {
  size: 24,
  color: "#0F63D8"
};
export default SvgBpt;